{{ 'cybercare.yearlyPrice.before' | translate }}
<span class="rs-price-s">
  <span class="rs-nowrap"
    ><span class="rs-euro">€</span><span class="rs-unit">{{ priceArray[0] }}</span
    ><span class="rs-decimal">.{{ priceArray[1] }}</span></span
  >
</span>
{{ 'cybercare.yearlyPrice.after' | translate }}
